import script from "./TextForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TextForm.vue?vue&type=script&setup=true&lang=js"

import "./TextForm.vue?vue&type=style&index=0&id=247d6f1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-247d6f1f"]])

export default __exports__